import styled, { css } from 'styled-components';
import { select } from '../../core/themev2';

const ContentLayout = styled.div`
  height: 60px;
  width: 100%;
  border-radius: 12px;
  padding: 0 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent};
  background-color: ${({ backgroundColor }) => select(backgroundColor)};
  .container-mobileTablet {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ${({ isDesktop, portalWithBanner }) =>
    !isDesktop &&
    css`
      position: fixed;
      top: ${portalWithBanner ? 89 : 59}px;
      background-color: white;
      box-shadow: 0px 2px 4px 0px #7c98a71a;
      border-radius: 0;
      left: 0;
      z-index: 4;
    `}
`;

const ActionContain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ marginRight }) => marginRight || '0px'};
  margin-left: ${({ marginLeft }) => marginLeft || '0px'};
`;

const StyledAction = styled.div`
  cursor: ${({ disabled, icon }) => (disabled ? 'not-allowed' : icon && 'pointer')};
  background-image: ${({ icon }) => `url(${icon})`};
  opacity: ${({ disabled }) => (disabled ? 0.25 : 1)};
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  background-size: ${({ backSize }) => backSize};
  position: relative;
  :hover {
    background-color: ${({ disabled }) => (disabled ? 'none' : select('midLightGray'))};
  }
`;

const Separator = styled.div`
  width: 1px;
  height: 30px;
  background-color: ${select('midLightGray')};
  margin-right: ${({ separatorType, spacing }) => (separatorType === 'preIcon' ? spacing : '0px')};
  margin-left: ${({ separatorType, spacing }) => (separatorType === 'postIcon' ? spacing : '0px')};
`;

export { ContentLayout, ActionContain, StyledAction, Separator };
